import React from 'react';
import Paper from "@mui/material/Paper";
import styled from "styled-components";
import useZibi from "../../../zibi/UseZibi";
import {DataItemStyled} from "./Edge";
import SensorStatus from "../../SensorStatus";

const WrapperStyled = styled.div`
    padding: 13px;

    .main-title {
        margin-bottom: 7px;
    }

    .ll1 {
        margin-right: 3px;
    }

    .ll2 {
        font-size: 13px;
        margin-right: 3px;
    }

    .ll3 {
        font-size: 11px;
        margin-right: 3px;
        font-weight: bold;
    }
`;

const DataWrapperStyled = styled.div`


`;

const DataListStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
`;

const DataItemLiStyled = styled.div`
    margin-top: 7px;

    .title {
        text-align: center;
        font-size: 15px;
        color: rgb(21, 21, 21);
        font-weight: 300;
    }
`;

const DataItemKioStyled = styled.div`
    position: relative;
    box-shadow: var(--mui-shadows-1);
    border-radius: 4px;
    margin: 3px;
    padding: 3px;
    font-size: 14px;
    
    .name{
        font-weight: 700;
    }
`;

const DataItemCamStyled = styled.div`
    position: relative;
    margin: 3px;
    padding: 3px;
    font-size: 14px;
    text-align: center;
    
    .name{
        font-weight: 700;
    }
`;


const Field = ({item}) => {
    const [siteEdges] = useZibi('siteEdges');
    const [siteCameras] = useZibi('siteCameras');
    const [sensors] = useZibi('sensors');
    const [sensorStatuses] = useZibi('sensorStatuses');
    const currentEdge = siteEdges?.find(p => p._id === item?.edgeId);

    return (
        <Paper elevation={3}>
            <WrapperStyled>
                <div className="main-title">
                    <span className="ll1">{item.name}</span>
                    <span className="ll2">({item.piNumber})</span>
                    <span className="ll3">|{`${item.width}x${item.height}`}|</span>
                </div>
                <DataWrapperStyled>
                    <DataItemStyled>
                        <div className="title">Edge:</div>
                        <div className="data">{currentEdge?.floorName}</div>
                    </DataItemStyled>
                    <DataListStyled>
                        <DataItemLiStyled>
                            <div className="title">Shelves</div>
                            <div className="data">
                                {item.shelves.map(sh => {
                                    let name = "No name";
                                    let status = null;
                                    let statusUpdateAt = null;
                                    const sensor = sensors[sh.sensorId];
                                    if (sensor) {
                                        name = sensor.boardId;
                                        const sensorStatusData = sensorStatuses[sh.sensorId];
                                        status = sensorStatusData?.status;
                                        statusUpdateAt = sensorStatusData?.statusUpdateAt;
                                    }
                                    return (
                                        <DataItemKioStyled key={sh._id}>
                                            <div className="name">{name}</div>
                                            <SensorStatus status={status} statusUpdateAt={statusUpdateAt}/>
                                        </DataItemKioStyled>
                                    );
                                })}</div>
                        </DataItemLiStyled>
                        <DataItemLiStyled>
                            <div className="title">Cameras:</div>
                            <div className="data">
                                {item.cameras.map(sh => {
                                    const cam = siteCameras[sh._id];
                                    return <DataItemCamStyled key={sh._id}>
                                        <div className="name">{cam?.name}</div>
                                    </DataItemCamStyled>;
                                })}</div>
                        </DataItemLiStyled>
                    </DataListStyled>
                </DataWrapperStyled>
            </WrapperStyled>
        </Paper>
    );
};

export default Field;